<template>
  <div class="contentBox">
    <div class="breadCrumbs mt-50">
      <el-breadcrumb separator="/" class="ml-15">
        <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
        <el-breadcrumb-item>Members</el-breadcrumb-item>
        <el-breadcrumb-item>{{ison}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="membersMain">
      <ul id="tabs">
        <li
          v-for="(item,key) in cate"
          :key="key"
          @click="tabsClickFn(item.id,item.name)"
          :class="{on:ison == item.name}"
        >
          <span>{{item.name}}</span>
        </li>
      </ul>
      <div class="mainBox">
        <div v-if="ison == '相册'"> 
          <el-tabs type="border-card" class="xiangce">
            <el-tab-pane label="Album">
              <span slot="label">
                <i class="el-icon-picture-outline"></i> Album
              </span>
              <div class="imgListBox">
                
                <ul class="imgUl">
                  <li v-for="(item,key) in imgList" :key = 'key'  >
                    <img :src='item.src' :preview="key" :preview-text="item.title"/>
                    <p class="title">{{item.title}}</p>
                    <p class="maintext">{{item.description}}</p>
                    <p class="tips"><span class="sp1"><i class="el-icon-time"></i>{{item.shoot_date}}</span></p>
                  </li>
                </ul>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
        <ul class="mainUl" v-if="ison != '相册'">
          <li v-for="(item,key) in membersList" :key="key">
            <div class="imgBox">
              <img :src="item.head">
            </div>
            <div class="maintext">
              <p class="title">
                <router-link :to="{name:'membersPeople',params:{id:item.id}}" @click.native="xiaodiClickFn(item.id)">{{item.name}}</router-link>
              </p>
              <p class="tips">{{item.school}}</p>
              <p class="tips">{{item.title}}</p>
              <p class="tips">{{item.meail}}</p>
              <p class="read">
                <span>{{item.join_date}}</span>
              </p>
            </div>
          </li>
        </ul>
        <div class="block pageBlock">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-size="5"
            layout="total,  prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "@/assets/css/members.less";
import { mapState } from "vuex";
import apiSign from "../assets/js/apiSign";
import "@/assets/css/opportunities.less";
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
export default {
  name: "membersMain",
  data() {
    return {
      namedata: "",
      cate: null,
      ison: "",
      membersList: [],
      memberstext: "",
      page:1,
      total:0,
      cateDictId:1,
      cateDictName:'',
      imgList: [],
    };
  },
  comptude: {
    membersName() {
      this.memberstext = this.$store.state.membersName;
    }
  },
  computed: {
    ...mapState({
      membersName: state => state.membersName
    })
  },
  watch: {
    membersName() {
      this.memberstext = this.$store.state.membersName;
      let cateDict = this.cate;
      if (cateDict != undefined) {
        Object.keys(cateDict).forEach(key => {
          if (cateDict[key].name == this.memberstext) {
            this.cateDictId = cateDict[key].id
            this.cateDictName = cateDict[key].name
            this.page = 1
            this.tabsClickFn();
          }
        });
      }
    }
  },
  mounted() {
    sessionStorage.setItem("membersName",'相册');
    this.$store.state.membersName = '相册'
    this.getFamilyImage();
    this.getImgList();
    this.getCate();
  },
  methods: {
    handleCurrentChange(val) {
      this.page = val;
      this.tabsClickFn();
    },
    tabsClickFn(tableId,tableName) {   //获取角色列表
      let id,name,page;
      if(tableId != undefined){
        id = tableId
        name = tableName
        page = 1
        this.cateDictId = tableId;
        this.cateDictName = tableName;
      }else{
        id = this.cateDictId
        name =this.cateDictName
        page = this.page
      }
      this.ison = name;
      let field = { rtime: apiSign.getTime(), cid: id ,page:page};
      this.axios
        .get(this.axios.defaults.baseURL + "/yiwei/members/lists", {
          headers: {
            sign: apiSign.sign(field)
          },
          params: field
        })
        .then(resp => {
          this.total = resp.data.data.total;
          this.page = resp.data.data.currentPage;
          this.membersList = resp.data.data.data;
        });
      this.$store.state.name = name;
    },
    getCate() {
      let statename = this.$store.state.membersName;
      let field = { rtime: apiSign.getTime() };
      this.axios
        .get(this.axios.defaults.baseURL + "/yiwei/members/cate", {
          headers: {
            sign: apiSign.sign(field)
          },
          params: field
        })
        .then(resp => {
          if (resp.data.code) {
            this.$message({
              type: "error",
              message: resp.data.msg
            });
          } else {
            if (Object.keys(resp.data.data).length) {
              let catename = resp.data.data;
                let membersName = sessionStorage.getItem("membersName");
                Object.keys(catename).forEach(item => {
                  if (catename[item].name == membersName) {
                    this.cateDictId = catename[item].id;
                    this.cateDictName = catename[item].name;
                    this.tabsClickFn();
                  }
                });
              this.cate = catename;
            } else {
              this.$message({
                type: "error",
                message: "人员分类为空"
              });
            }
          }
        })
        .catch(err => {
          this.$message({
            type: "error",
            message: err
          });
        });
    },
    xiaodiClickFn(id){
      sessionStorage.setItem('yiweiId',id);
      this.$store.state.membersId  = id;
    },
    
    getImgList() {
      let field = { rtime: apiSign.getTime() };
      this.axios.get(this.axios.defaults.baseURL +'/yiwei/app/opportunities',{
        headers: {
            sign: apiSign.sign(field)
          },
          params: field
      }).then(resp=>{
        this.opportunities = resp.data.data.opportunities
      })
      this.axios
        .get(this.axios.defaults.baseURL + "/yiwei/album/lists", {
          headers: {
            sign: apiSign.sign(field)
          },
          params: field
        })
        .then(resp => {
          let respList = resp.data.data.data;
          let imgList = [];
          Object.keys(respList).forEach(key => {
            let imgDict = {};
            imgDict["src"] = respList[key].image;
            imgDict["title"] = respList[key].title;
            imgDict["description"] = respList[key].description;
            imgDict["shoot_date"] = respList[key].shoot_date;
            imgList.push(imgDict);
          });
          this.imgList = imgList;
          this.$previewRefresh()
        });
    },
    getFamilyImage(){
      let field = {rtime:apiSign.getTime()}
      let storageFamily = sessionStorage.getItem('family');
      if(storageFamily){
        this.family = storageFamily
      }
      this.axios
        .get(this.axios.defaults.baseURL + "/yiwei/app/family",
          {
            headers:{
              sign:apiSign.sign(field)
            },
            params:field
          }
        )
        .then(resp => {
          if(resp.data.code){
            this.$message({
              type: 'error',
              message: resp.data.msg
            });
          }else{
            if ('family' in resp.data.data){
              this.family = resp.data.data.family
              sessionStorage.setItem('family', this.family)
            }else{
              this.$message({
                type: 'error',
                message: 'family照片不存在'
              });
            }
          }

        })
        .catch(err => {
          this.$message({
            type: 'error',
            message: err
          });
        });
    }
  }
};
</script>
